import { spaceClient } from './client';

export const getTeleportTable = () =>
  spaceClient.get('/cms/teleport_table').then((r) => r.data);

export const updateTeleportTable = (tableId, payload) =>
  spaceClient.put(`/teleport_table/${tableId}`, payload).then((r) => r.data);

export const deleteTeleportButton = (tableId, buttonId) =>
  spaceClient.delete(`/teleport_table/${tableId}/button/${buttonId}`).then((r) => r.data);

export const createTeleportButton = (tableId, payload) =>
  spaceClient.post(`/teleport_table/${tableId}/button`, payload).then((r) => r.data);

export const submitButtonPositionChange = (tableId, buttonId, positionId) =>
  spaceClient
    .post(`/teleport_table/${tableId}/button/${buttonId}/submit-position-change`, { positionId })
    .then((r) => r.data);
